import { Phone, MessageCircle, Mail, Bell } from "lucide-react";

const CHANNELS = [
  { value: "call", label: "Call", Icon: Phone },
  { value: "whatsapp", label: "WhatsApp", Icon: MessageCircle },
  { value: "email", label: "Email", Icon: Mail },
  { value: "in_app", label: "In-app", Icon: Bell },
];

export default function ChannelSelector({ value, onChange }) {
  return (
    <div className="flex gap-2">
      {CHANNELS.map(({ value: v, label, Icon }) => (
        <button
          key={v}
          type="button"
          onClick={() => onChange(v)}
          className={`flex flex-1 flex-col items-center gap-1 rounded-lg py-2.5 text-xs font-medium transition-colors ${
            v === value
              ? "bg-navy text-white"
              : "bg-navy/5 text-navy hover:bg-navy/10"
          }`}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </div>
  );
}
